/* eslint-disable import/no-unused-modules */
import { gql } from '@apollo/client';

export const GET_BLOGS = gql`
  query getHostingPlan {
    getHostingPlan {
      blogs {
        blogTitle
        defaultAddPosts
        id
        expiryDate
      }
    }
  }
`;

export const GET_HOSTING_PLAN = gql`
  query getHostingPlan {
    getHostingPlan {
      blogs {
        blogTitle
        blogSlogan
        logo
        darkLogo
        defaultDarkMode
        squareLogo
        logoDimensions {
          width
          height
        }
        darkLogoDimensions {
          width
          height
        }
        primaryColor
        defaultAddPosts
        redirectSubdomain
        googleAnalyticsId
        headerInjection
        useHostingUrl
        adstxt
        editKey
        id
        expiryDate
        isCancelled
        plan
        domain
        # deployedToday
        analyticsApi
      }
      hasVerifiedEmail
    }
  }
`;

export const CHECK_BLOG_AVAILABILITY = gql`
  query checkBlogAvailability($id: String!) {
    checkBlogAvailability(id: $id)
  }
`;

export const BLOG_DEPLOYMENT_STATE = gql`
  query blogDeploymentState($id: String!) {
    blogDeploymentState(id: $id)
  }
`;

export const CREATE_BLOG = gql`
  mutation createBlog(
    $id: String!
    $initialPosts: [String]
    $settings: BlogBasicSettings!
  ) {
    createBlog(id: $id, initialPosts: $initialPosts, settings: $settings) {
      success
      message
    }
  }
`;

export const BASIC_BLOG_SETTINGS = gql`
  mutation basicBlogSettings($id: String!, $settings: BlogBasicSettings!) {
    basicBlogSettings(id: $id, settings: $settings) {
      success
      message
    }
  }
`;

export const ADD_DOMAIN = gql`
  mutation addDomain($domain: String!, $blogId: String!) {
    addDomain(domain: $domain, blogId: $blogId) {
      success
      message
    }
  }
`;

export const REMOVE_DOMAIN = gql`
  mutation removeDomain($blogId: String!) {
    removeDomain(blogId: $blogId) {
      success
      message
    }
  }
`;

export const CONFIRM_GUEST_COMMENT = gql`
  mutation confirmGuestComment($token: String!) {
    confirmGuestComment(token: $token) {
      success
      message
    }
  }
`;

export const UNGLAG_COMMENT = gql`
  mutation unFlagComment($commentId: String!) {
    unFlagComment(commentId: $commentId) {
      success
      message
    }
  }
`;
